module.exports = __webpack_public_path__ + "static/step-2-cbfc5577c1e5b4b428bd70baaa1f0416.svg";